(() => {
  const init = () => {
    const root = document.getElementById('MainContent');
    if (!root) return;
    const properties = ['background','background-color','background-image','color','border','border-radius','box-shadow','font-size'];
    const refresh = () => {
      root.querySelectorAll('._rsi-buy-now-button:not(#_rsi-buy-now-button-floating)').forEach(button => {
        properties.forEach(property => {
          if (button.style.getPropertyValue(property)) button.style.removeProperty(property);
        });
      });
    };
    refresh();
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; refresh(); });
    }).observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['style']});
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
